export const exterior_view05ImageOptions = {
  angle: 'exterior_view05',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: 'SprayHood'
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/exterior_view05.js